// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"91":"2fe1b8e8","461":"fe83681a","755":"07028839"}[chunkId] + ".chunk.css";
};